import {
  DateField,
  EmailField,
  ReferenceField,
  Show,
  SimpleShowLayout,
  TextField,
  usePermissions,
  useTranslate,
} from 'react-admin';
import { Admin_Roles } from 'src/utils/enum';

const SubscriptionShow = () => {
  const { permissions } = usePermissions();
  const translate = useTranslate();
  return (
    <Show>
      <SimpleShowLayout>
        <TextField source="id" />
        <TextField source="display_name" label={translate('resources.subscriptions.fields.display_name')} />
        <EmailField source="email" label={translate('resources.subscriptions.fields.email')} />
        <ReferenceField
          source="updated_by"
          reference="Subscription"
          label={translate('resources.subscriptions.fields.updated_by')}
        />
        <DateField
          source="updated_at"
          showTime
          locales="ja-JP"
          label={translate('resources.subscriptions.fields.updated_at')}
        />
        {Admin_Roles.includes(permissions) && (
          <ReferenceField
            source="created_by"
            reference="Subscription"
            label={translate('resources.subscriptions.fields.created_by')}
          />
        )}
        <DateField
          source="created_at"
          showTime
          locales="ja-JP"
          label={translate('resources.subscriptions.fields.created_at')}
        />
      </SimpleShowLayout>
    </Show>
  );
};

export default SubscriptionShow;
